import React from "react";

/**
 * 最小化中にランチャーの上へ出す動画プレビュー。
 * lead-dynamics の widget.js renderVideoPreview() を移植したもの。
 *
 * ・PC(601px以上) = autoplay モード: 選択した動画のアスペクトに合わせた枠で自動再生。
 * ・スマホ(600px以下) = trigger モード: 90px の丸トリガー＋「動画で見る」ラベル。
 *
 * どちらもクリック/タップで拡大プレイヤー(ExpandedVideo)が開く。
 * LD は PC だけチャットを開いていたが、拡大プレイヤーを右下ドッキング型にしたため
 * PC でも動画を大きく見せてから CTA に進ませる形に揃えている。
 *
 * どちらも × でセッション中だけ非表示にできる（LD の state._videoDismissed 相当）。
 */

// muted/autoplay/loop/playsinline は属性としても明示する。
// iOS Safari は playsinline が属性で無いとインライン再生してくれない。
const videoProps = {
  muted: true,
  autoPlay: true,
  loop: true,
  playsInline: true,
  "webkit-playsinline": "",
  preload: "auto",
};

const VideoPreview = (props) => {
  const { url, mobile, vertical, onOpenFullscreen, onDismiss } = props;

  const dismiss = (event) => {
    event.stopPropagation();
    onDismiss();
  };

  if (mobile) {
    return (
      <div className="aisdr-vtm-wrap">
        <span className="aisdr-vtm-label" onClick={onOpenFullscreen}>
          動画で見る
        </span>
        <div className="aisdr-vtm-btn" onClick={onOpenFullscreen}>
          <video src={url} {...videoProps} />
          <div className="aisdr-vtm-play">
            <svg viewBox="0 0 24 24" width="26" height="26" fill="#fff">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
          <span className="aisdr-vtm-close" onClick={dismiss}>
            ×
          </span>
        </div>
      </div>
    );
  }

  // 9:16 = 180x320 / 16:9 = 260x146（LD と同じ実寸）
  return (
    <div
      className="aisdr-video-preview"
      style={{
        width: vertical ? "180px" : "260px",
        height: vertical ? "320px" : "146px",
      }}
      onClick={onOpenFullscreen}
    >
      <video src={url} {...videoProps} />
      <span className="aisdr-vp-close" onClick={dismiss}>
        ×
      </span>
    </div>
  );
};

export default VideoPreview;
